const environment =
  process.env.NODE_ENV === 'development'
    ? 'stg'
    : document.documentElement.dataset.vanEnv || 'prod'

export const API_HOST = {
  stg: 'https://download-api-stg.xiaolachuxing.com',
  pre: 'https://download-api-pre.xiaolachuxing.com',
  prod: 'https://download-api.xiaolachuxing.com'
}[environment]
